export const SIGNAL_OPERATOR = "SIGNAL_OPERATOR";

export const SERVICES_LIST = [SIGNAL_OPERATOR, "SIGNAL_NOTIFY"];
